export default "__VITE_ASSET__a2a26a77__"